import { makeStyles } from '@material-ui/core';
import { themeColor } from '../../mui-theme';
import { rem, vh } from '../../common/helpers/dimension-helper';

export const styles = makeStyles(theme => ({
  navBarContainer: {
    textAlign: 'center',
  },
  arrowButtons: {
    color: theme.palette.info.main,
  },
  listContainer: {
    position: 'relative',
    height: vh(50),
  },
  scrollContainer: {
    display: 'block',
    maxHeight: vh(40),
    '@media (max-width: 1024px)': {
      maxHeight: vh(35),
    },
    paddingTop: vh(2),
  },
  resultsContainer: {
    display: 'block',
  },
  badge: {
    paddingTop: '1.8vh',
    position: 'relative',
    left: 20,
    top: 4,
    float: 'left',
  },
  disabledLineItem: {
    opacity: 0.6,
    borderColor: themeColor.lightgray,
  },
  exchangeNavButtonContainer: {
    position: 'absolute',
    bottom: 40,
  },
  resultsItem: {
    height: '6.5vh',
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    fontSize: rem(0.875),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: '0.17px',
    color: themeColor.almostblack,
    paddingLeft: '1.02vw',
    paddingRight: '1.02vw',
    '@media (height: 1080px) and (width: 1920px)': {
      fontSize: rem(1.125),
    },
  },
  selected: {
    borderRadius: '2px',
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  container: {
    padding: '0 0 10px 10px',
    backgroundColor: themeColor.verylightgrey,
  },
  closeButton: {
    width: '8.19vw',
    height: '56px',
    fontWeight: 500,
    lineHeight: 1,
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    color: themeColor.defaultTextColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
    '& .MuiTouchRipple-ripple': {
      color: `${theme.palette.secondary.main}`,
    },
  },
  rightButton: {
    marginRight: '10px',
    height: '56px',
    fontWeight: 500,
    lineHeight: 1,
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  rightAlign: {
    textAlign: 'right',
  },
  leftAlign: {
    textAlign: 'left',
  },
  customMargin: {
    margin: 16,
  },
}));
